import React, { useState } from "react";
import { Button, Text, View } from "../../Components/Themed";
import { useColors } from "../../constants/useColors";
import type { CompanyProps } from "../../types";
import { FlatList, Image } from "react-native";
import { Icons } from "../../Components";


type CompanySelectorProps = {
    active_company?:CompanyProps,
    companies:CompanyProps[],
    onSelectCompany:(c?:CompanyProps) => void
}
const CompanySelector = ({ active_company, companies, onSelectCompany }:CompanySelectorProps) => {
    const Colors = useColors();
    const [ visible, setVisible ] = useState(false);

    const renderCompanies = (data:{ item:CompanyProps, index:number }) => {
        return (
            <Button 
                transparent 
                style={{ flexDirection:'row', alignItems:'center', padding:10, borderRadius:0, borderBottomWidth:1, borderColor:Colors.borders.light }}
                onPress={() => { setVisible(false); onSelectCompany(data.item) }}
            >
                <Image
                    source={{ uri: data.item.company_image?.url }}
                    style={{ height:40, width:40 }}
                    resizeMode='cover'
                />
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme='h1'>{data.item.company_name}</Text>
                    <Text theme='description' style={{ marginTop:3 }}>{data.item.company_description}</Text>
                </View>
            </Button>
        )
    }

    return (
        <Button float onPress={() => { setVisible(!visible); onSelectCompany(undefined) }}>
            <View transparent style={{ flexDirection:'row', alignItems:'center' }}>
                <Text style={{ flex:1, marginRight:10 }} theme='h1'>{active_company?.company_name ?? 'No Company'}</Text>
                <Icons.ChevronIcon direction={visible?'up':'down'} color={Colors.text.h1} size={8} />
            </View>
            {visible ?
            <View transparent style={{ marginTop:20 }}>
            <FlatList
                data={companies}
                key={'company_selector'}
                keyExtractor={item => item.company_id.toString()}
                renderItem={renderCompanies}
            />
            </View>
            :<></>}
        </Button>
    )
}

export default CompanySelector